import "./App.css";
import AppRoutes from "./App-route";
import { useEffect } from "react";
import useAuthStore from "./store";
import { OctopianSDKConfig } from "octopian-apis";
import { Init as UIInit } from "octopian-ui-sdk";

function App() {
  useEffect(() => {
    OctopianSDKConfig.Init(
      "c2f39971caba41ea8c9c1991564b67b3",
      "https://apim.octopian.cloud/"
    );

    useAuthStore.getState().syncAuth();

    const token = localStorage.getItem("octopian_token");
    console.log("Octopian token:", token);
    if (token) {
      UIInit(
        "1a2c35cc134044378ba986b434707f95",
        "https://apim.octopian.cloud/",
        token
      );
    } else {
      console.warn("Octopian token not found in localStorage.");
    }
  }, []);

  return (
    <div className="App">
      <AppRoutes />
    </div>
  );
}

export default App;
